import NotificationRuleAction, { DefaultNotificationRuleAction } from "./NotificationRuleAction";
import NotificationRuleCondition, { DefaultNotificationRuleCondition } from "./NotificationRuleCondition";

export default interface NotificationRule {
    notificationRuleId?: number;
    title: string;
    tenantId?: number;
    actions: NotificationRuleAction[];
    ruleActions?: NotificationRuleAction[];
    conditions: NotificationRuleCondition[];
}

export const DefaultNotificationRule: NotificationRule = {
    notificationRuleId: null,
    tenantId: null,
    title: "",
    actions: [DefaultNotificationRuleAction],
    conditions: [DefaultNotificationRuleCondition]
}